import React from "react";
import { Box, Button, Typography } from "@mui/material";
import BasePaper from "components/Base/BasePaper";
import NonEditableFieldsTable from "components/Records/RecordDisplay/NonEditableFieldTable";

interface StepFinalImportProps {
  validation?: {
    valid_rows?: number;
  };
  importFile: () => void;
  uploading: boolean;
  importResult?: {
    created_count?: number;
    errors?: any[];
  };
}

export const StepFinalImport: React.FC<StepFinalImportProps> = ({ validation, importFile, uploading, importResult }) => (
  <BasePaper>
    {validation && !importResult && (
      <Typography sx={{ mb: 2 }}>
        You are about to import {validation.valid_rows ?? "?"} valid rows.
      </Typography>
    )}

    {importResult && (
      <>
        <Typography sx={{ mb: 2 }}>
          You have imported the data successfully.
        </Typography>
        <Typography>Created: {importResult.created_count ?? 0}</Typography>
        <Typography>Errors: {importResult.errors?.length ?? 0}</Typography>
      </>
    )}
  </BasePaper>

);
